/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import React from "react";
import { TextField } from "@mui/material";
import { FieldConfig, useField } from "formik";
import { styled } from "@iventis/styles";
import { StyledFieldLabel } from "@iventis/styles/src/components/forms";

interface CustomFormikTextFieldProps extends FieldConfig {
    label?: string;
    placeholder?: string;
    name: string;
    className?: string;
    width?: string;
    marginTop?: string | number; // this is used to align 2 separate input boxes in the same flex when they share a single label (a value with double input)
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    multiline?: boolean;
    rows?: number;
}
const CustomFormikTextField: React.FunctionComponent<CustomFormikTextFieldProps> = ({
    label,
    className,
    width,
    marginTop,
    value,
    onChange,
    placeholder,
    disabled,
    multiline,
    rows,
    ...props
}) => {
    const { name, component, children, ...restProps } = props;
    const [field, meta] = useField(name);
    return (
        <StyledCustomFormikFieldBox className={className}>
            {label ? <StyledFieldLabel>{label}</StyledFieldLabel> : ""}
            <TextField
                {...field}
                {...restProps}
                placeholder={placeholder}
                error={!!(meta.touched && meta.error)}
                helperText={meta.touched && meta.error}
                onBlur={field.onBlur}
                variant="outlined"
                style={{ marginTop: marginTop || 0 }}
                value={value}
                onChange={onChange}
                disabled={disabled}
                multiline={multiline}
                rows={rows}
                name={name}
            >
                {children as React.ReactNode}
            </TextField>
        </StyledCustomFormikFieldBox>
    );
};
const StyledCustomFormikFieldBox = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;
export default CustomFormikTextField;
